export const parsePointString = (point: string): { latitude: number; longitude: number } => {
  const [latitude, longitude] = point.split(',').map(Number);

  return { latitude, longitude };
};

export const toPointString = (coordinates: number[]): string => {
  const geoPoint = `${coordinates[0]},${coordinates[1]}`;

  return geoPoint;
};
